import { z } from 'zod'
import { isoDateTimeSchema } from '@customTypes/cloudmix/api'

export const EXPORT_FORMAT = {
  mp4: 'mp4',
} as const
export const exportFormatSchema = z.nativeEnum(EXPORT_FORMAT)
export type ExportFormat = z.infer<typeof exportFormatSchema>
export const exportFormats = Object.values(EXPORT_FORMAT)

export const EXPORT_STATUS = {
  processing: 'processing',
  available: 'available',
  failed: 'failed',
} as const
export const exportStatusSchema = z.nativeEnum(EXPORT_STATUS)
export type ExportStatus = z.infer<typeof exportStatusSchema>

export const exportSchema = z.object({
  mediaExportId: z.string().uuid(),
  format: exportFormatSchema,
  status: exportStatusSchema,
  requestedAt: isoDateTimeSchema,
  startedAt: isoDateTimeSchema.nullable(),
  completedAt: isoDateTimeSchema.nullable(),
  lastUpdatedAt: isoDateTimeSchema,
})
export type Export = z.infer<typeof exportSchema>

export const exportRequestSchema = z.object({
  format: exportFormatSchema,
})
export type ExportRequest = z.infer<typeof exportRequestSchema>

export const mediaExportIdSchema = z.string().uuid()
export type MediaExportId = z.infer<typeof mediaExportIdSchema>

export const exportResponseSchema = z.object({
  mediaExportId: mediaExportIdSchema,
})
export type ExportResponse = z.infer<typeof exportResponseSchema>

export const downloadExportRequestSchema = z.object({
  mediaExportId: mediaExportIdSchema,
})
export type DownloadExportRequest = z.infer<typeof downloadExportRequestSchema>

export const downloadExportResponseSchema = z.object({
  url: z.string().url(),
})
export type DownloadExportResponse = z.infer<
  typeof downloadExportResponseSchema
>
